import {Link} from 'shared/pretty-easy-navigation/models';
import {NavigationContext} from '../navigation.context';

export const MyCorpusLink = (context: NavigationContext): Link => ({
    type: 'link',
    label: 'navigation.corpus_user',
    link: '/corpus/user/' + context.currentUserCorpusId,
    icon: 'navigation-link__list-item',
});